import { Grid2, IconButton, Typography } from "@mui/material";
import AppCard from "../../../genericComponents/AppCard";
import { gql, useQuery } from "@apollo/client";
import Loader from "../../../genericComponents/Loader";
import { Info, MoreVertOutlined } from "@mui/icons-material";
import { useSideScreen } from "../../../Layout/backoffice";
import UsageDetails from "../../../sidescreen/usageDetails";

const MeterDetailsCards = ({ id, icon, meterType, start, end, name }) => {
  const TOTALQUERY = `query getTotals($id:UUID!,$meterType:MeterType! $level:Level!,$start:DateTime!,$end:DateTime!){
        totalData(chartInput:{id: $id,level: $level, meterType: $meterType,start:$start ,end:$end}){
          value
        }
          }`;
  const { openSideScreen } = useSideScreen();
  const { data, loading } = useQuery(gql(TOTALQUERY), {
    variables: {
      id: id,
      level: "METER",
      meterType: meterType,
      start: start,
      end: end,
    },
  });
  const unit = meterType == "GAS" ? " m3" : " kWh";

  return (
    <Grid2 xs={12} spacing={2} sx={{flexGrow:1}} container>
      <Grid2 size={{ xs: 12, sm: 6 }}>
        <AppCard          
          headerAction={
            <div style={{ display: "flex" }}>
              <IconButton
                onClick={() =>
                  openSideScreen(UsageDetails, {
                    data: {
                      id: id,
                      end: end,
                      start: start,
                      level: "METER",
                      meterType: meterType,
                    },
                  })
                }
                aria-label="settings"
              >
                <Info />
              </IconButton>
            </div>
          }
          shouldCenter={true}
          title={meterType == "GAS" ? "i18n_gtotal" : "i18n_etotal"}
          icon={icon}
        >
          <Typography variant="h1">
            {!data || loading ? (
              <Loader />
            ) : (
              data.totalData.value.toLocaleString() + " " + unit
            )}
          </Typography>
        </AppCard>
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 6 }}>
        <AppCard shouldCenter={true} title={"EAN"} icon={icon}>
          <Typography variant="h1">{name}</Typography>
        </AppCard>
      </Grid2>
    </Grid2>
  );
};

export default MeterDetailsCards;
